import React from "react";
import { Link } from "react-router-dom";

const questions = [
  [
    "What is Birdwatcher?",
    "Birdwatcher is an Agroadvisor field-measurement project for continuous poultry population monitoring. It combines camera-based observation with sampling, calibration and deployment logic so the reported result can be interpreted at flock level, not only at individual-bird level.",
  ],
  [
    "Is the goal to replace manual weighing or scales?",
    "No. Manual measurements and scales can provide stronger individual measurements. Birdwatcher focuses on the complementary problem of observing a much larger share of the flock repeatedly and understanding how measurement error and sampling error combine.",
  ],
  [
    "Does Birdwatcher only mean an AI model?",
    "No. The model is one component. Camera placement, sampling coverage, calibration, model drift, data quality, operational monitoring and validation all influence whether a field estimate remains useful.",
  ],
  [
    "How is the system calibrated?",
    "Calibration is deployment-specific. Reference measurements can be used to detect systematic differences between environments and to update or correct the operational estimate without pretending that one historical validation is universally transferable.",
  ],
  [
    "What happens when conditions change?",
    "Lighting, density, genetics, bird behaviour, equipment and building geometry can all shift. Birdwatcher is designed around monitoring these sources of drift and making uncertainty and error sources visible enough to investigate.",
  ],
  [
    "Who owns farm and measurement data?",
    "Data ownership and permitted processing are defined by the applicable customer agreement and deployment documentation. Birdwatcher does not treat customer operational data as public data.",
  ],
  [
    "Does this public website use tracking or advertising cookies?",
    "The current public Birdwatcher website is intended to operate without advertising or behavioural tracking. Technical infrastructure may still process standard request and security logs. See the privacy notice for the current details.",
  ],
  [
    "Can I request a demo or research collaboration?",
    "Yes. Use the contact page or email info@agroadvisor.hu. The web form remains disabled until its AWS endpoint is connected, so no form data is collected before that integration is active.",
  ],
];

export default function FaqPage() {
  return (
    <div className="page legal-page">
      <section className="page-section legal-hero">
        <p className="eyebrow">Birdwatcher · FAQ</p>
        <h1>Questions worth asking before trusting a number.</h1>
        <p className="hero-intro">Short answers about the project, field deployment, measurement philosophy and how the public website handles contact data.</p>
      </section>

      <section className="page-section compact-section faq-list" aria-label="Frequently asked questions">
        {questions.map(([question, answer], index) => (
          <details key={question} className="faq-item" open={index === 0}>
            <summary>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <strong>{question}</strong>
              <i aria-hidden="true">+</i>
            </summary>
            <div className="faq-answer"><p>{answer}</p></div>
          </details>
        ))}
      </section>

      <section className="page-section legal-cta compact-section">
        <div>
          <span className="section-label">Still specific?</span>
          <h2>Ask about the deployment you actually have.</h2>
        </div>
        <Link className="button button-primary" to="/contact">Contact Agroadvisor</Link>
      </section>
    </div>
  );
}
